<template>
  <PageContainer :config="config" />
</template>

<script setup>
import { inject, computed } from "vue";
import PageContainer from "~/components/PageContainer";
import { useRoute } from "vue-router";
import { interval } from "~/utils/miscellaneous";

const { siteConfigUtils } = inject("siteConfig");
const route = useRoute();

const config = computed(() => siteConfigUtils.getPageConfig(route.path));

interval(
  () =>
    (document.title = `${document.title.split("-")[0]} - ${
      config.value.label
    }`),
  1000,
  5
);
</script>
